<template>
  <div class="main">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            工单信息
          </div>
        </template>
        <div class="collapse-content">
          <SiruiSearch
            ref="baseInfoFormRef"
            :query="baseFormData"
            :columns="formColumn"
            :isQueryPanel="false"
            :isDisabledForm="true"
          ></SiruiSearch>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            维修项目
          </div>
        </template>
        <div class="collapse-content">
          <RepairProjectTable :data="componentTableData"></RepairProjectTable>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件
          </div>
        </template>
        <div class="collapse-content">
          <FileTable ref="fileTableRef" isShowDownBtn :attachments="attachments" />
        </div>
      </el-collapse-item>
      <el-collapse-item name="4">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            验收记录
          </div>
        </template>
        <div class="collapse-content">
          <sirui-table
            ref="siruiTable"
            :loading="load"
            :data="tableData"
            :paging="true"
            :setting="false"
            :customVisible="false"
            :columns="columnListDefault"
            :showToolbar="false"
            class="marginTop"
            height="200"
          >
            <vxe-table-column type="seq" title="序号" width="50"></vxe-table-column>
            <vxe-table-column
              v-for="(item, index) in columnListDefault"
              :key="index"
              :fixed="item.fixed"
              :sortable="item.sortable"
              :field="item.field"
              :title="item.title ? $t(item.title) : null"
              :visible="item.visible"
              :type="item.type"
              :width="item.width"
            >
            </vxe-table-column>
          </sirui-table>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
  import RepairProjectTable from '../components/RepairProjectTable.vue';
  import { formColumn, columnListDefault } from './index.js';
  import API from '@/api/property/workorder.js';
  // import { formatDate } from '@/utils/date';
  import mixin from './../mixin.js';

  export default {
    name: 'workorderDetail',
    mixins: [mixin],
    data() {
      return {
        activeNames: ['1', '2', '3', '4'],
        attachments: [],
        input: '',
        load: false,
        id: '',
        tableData: [],
        baseFormData: {},
        columnListDefault: columnListDefault,
        componentTableData: [],
      };
    },
    computed: {
      formColumn() {
        return formColumn(this);
      },
    },
    mounted() {
      // 接收参数
      let id;
      if (this.$route.query.workOrderId) {
        //维修管理的跳转
        id = this.$route.query.workOrderId;
      } else {
        id = this.$route.query.id;
      }
      this.getDetail(id);
    },
    methods: {
      onSubmit() {
        console.log('submit!');
        console.log(this.$refs.siruiTable);
      },
      // 获取详情信息
      async getDetail(id) {
        let { data } = await this.$axios.post(`${API.WORKORDER_DETAIL}/${id}`);
        if (data.code == 0) {
          this.baseFormData = this.translateFiled(data.data, 'workOrderDTO');
          this.componentTableData = Object.freeze(
            this.translateFiled(data.data.workOrderProjectVOList, 'workOrderProjectVOList')
          );
          this.attachments = data.data.attachments;
          let tempData = data.data.workOrderCheckRecordVOList.map((item) => {
            return {
              ...item,
              gmtCreate: Date.parse(item.gmtCreate),
            };
          });
          tempData = tempData.sort((a, b) => {
            return b.gmtCreate - a.gmtCreate; // 按照验收记录创建时间倒叙
          });
          data.data.companyCode && this.getDepartment(data.data.companyCode);
          console.log(tempData, 'tempData');
          this.tableData = Object.freeze(
            this.translateFiled(tempData, 'workOrderCheckRecordVOList')
          );
        }
      },
    },
    components: { RepairProjectTable },
  };
</script>

<style scoped>
  .marginTop {
    margin-top: -46px;
  }
</style>
